import React from 'react';
import MetaComissaoReport from '../components/meta-comissao/MetaComissaoReport';

const Page: React.FC = () => {
  return (
    <div className="p-4">
      <MetaComissaoReport />
    </div>
  );
};

export default Page;
